export const default_bck_color: string  = '#4c9be7';

export const getLanguageFromBrowser = (): string => {
    const language = navigator.language.split(/[-_]/)[0] || (navigator as any).userLanguage.split(/[-_]/)[0];
    return language || 'en';
  }